import React from 'react'
import styles from './css/help.module.css';
import Navbar from '../Components/Navbar/Navbar';
const Help = () => {
    return (
        <>
            <div className={styles.navbarhandler}>
                <Navbar />
            </div>
            <div className={styles.main_container}>


                <div className={styles.container}>
                    <div className={styles.title}>
                        Types Of Lawyers
                    </div>
                    <div className={styles.brief}>
                        This section will briefly tell about the types of lawyers so as to make you easier to choose your next lawyer.
                    </div>





                    <div className={styles.heading}>
                        Criminal Law
                    </div>
                    <div className={styles.text}>

                        Criminal law focuses on behaviors that are sanctioned under criminal code and defined as illegal. Prosecutors and District Attorneys sanction illegal behavior, while criminal defense lawyers represent clients accused of criminal activity. Both prosecution and defense professionals deal with issues of individual liberty, basic rights, and responsibilities. In some Common Law countries other than the U.S., and in most Civil Law countries, the roles of a prosecutor (or procurator) and defense lawyer (or advocate) are separated more clearly into different professional specialties. Learn more at: National Association of Criminal Defense Lawyers
                    </div>







                    <div className={styles.heading}>
                        Bankruptcy Law
                    </div>
                    <div className={styles.text}>
                        U.S. Bankruptcy law applies to the insolvency problems of individuals as well as organizations. This type of law issues directly from the Constitution and is in the domain of Federal law, though State laws have an important effect on bankruptcy procedure. Legal practitioners in this field are experts in the U.S. Bankruptcy Code, which is a subset of the United States Code. Learn more at: National Association of Consumer Bankruptcy Attorneys
                    </div>


                    <div className={styles.heading}>
                        Business (Corporate) Law
                    </div>
                    <div className={styles.text}>
                        Corporate law involves the formation, dissolution, and all other legal aspects of the administration of corporations. Typical duties of corporate lawyers include mergers, acquisitions, internal reorganization, or disputes between corporations and individuals concerning liability, patents, and compliance with state and federal law, as well as international accords. A legal professional whose sole client is a corporation is generally known as in-house counsel. Learn more at: Association of Corporate Counsel

                    </div>


                    <div className={styles.heading}>
                        Civil Rights Law
                    </div>
                    <div className={styles.text}>
                        Civil rights law aims to balance competing interests between institutions of government on the one hand and individuals or groups of individuals on the other. Lawyers in such practice may work on cases involving discrimination and unfair practices that infringe on rights and liberties such as expression, employment, housing, education, or other entitlements. Learn more at: Civil Rights Trial Lawyers Association

                    </div>




                    <div className={styles.heading}>
                        Entertainment Law
                    </div>
                    <div className={styles.text}>
                        Entertainment law predominantly relates to Intellectual Property Law, but is more specifically centered on rights and royalties issues to media in the arts, music, television, cinema, or athletics. Sports lawyers ensure compliance with regulations for professional or amateur athletics and may represent an athlete for a contractual transaction. With the rapid development of information technology and social media, entertainment lawyers operate in an environment of constant change. Learn more at: International Association of Entertainment Lawyers

                    </div>




                    <div className={styles.heading}>
                        Environmental Law
                    </div>
                    <div className={styles.text}>
                        Environmental law concerns a multitude of statutes, treaties, regulations, and conventions based in state, federal, or transnational law. Legal professionals practicing in this field may represent government agencies, advocacy organizations, or individuals. Environmental lawyers often focus on cases involving natural resource management, the curbing of pollution, or disputes about land and littoral use. Public health components are increasingly common in the practice of environmental law. Learn more at: National Association of Environmantal Law Societies (website in transition)

                    </div>



                    <div className={styles.heading}>
                        Family Law
                    </div>
                    <div className={styles.text}>
                        Family law focuses on legal relations between individuals in the context of the family. Lawyers in this field typically work in smaller firms and specialize in a variety of areas ranging from child welfare, through adoption, to divorce. Child abuse, legitimacy, civil unions, domestic partnerships, and marriages are among the main aspects of family lawyers' practice. Learn more at: American Academy of Matrimonial Lawyers

                    </div>




                    <div className={styles.heading}>
                        Health Law
                    </div>
                    <div className={styles.text}>
                        Health law is an evolving field that focuses on legislation related to health care. Health law attorneys may represent patients, clinics, insurance companies, or individual health practitioners. The federal government employs attorneys in this field to oversee the crafting, implementation, and enforcement of policies. Health law specialists also work at academic institutions and biotechnology and pharmaceutical companies. Learn more at: American Health Lawyers Association

                    </div>





                    <div className={styles.heading}>
                        Immigration Law
                    </div>
                    <div className={styles.text}>

                        Immigration lawyers work with individual clients at all stages of the naturalization process. Other aspects of the profession relate to refugee and asylum seekers, as well as to individuals in the country without legal permission. This field of law varies significantly from country to country. Much of its practice depends on international treaties, bilateral accords, and political conjecture. Learn more at: American Immigration Lawyers Association
                    </div>




                    <div className={styles.heading}>
                        Intellectual Property Law
                    </div>
                    <div className={styles.text}>
                        ntellectual Property law focuses on protecting the rights of inventors, authors, and businesses to their tangible and intangible creations, inventions and symbols.  Legal professionals in this field are often experts in a particular domain, such as science, the arts, or an industry. For example, trademark or copyright attorneys manage the legal aspects of contracts, visual identity, brand names, or slogans. Technological advances, notably in digital reproduction and transmission, make this a dynamic field of law. Learn more at: American Intellectual Property Law Association

                    </div>




                    <div className={styles.heading}>
                        International Law
                    </div>
                    <div className={styles.text}>
                        International law is broad in its conception and can be broken down into private and public sectors. In the private sector, specialists in international law may work in finance and trade divisions of multinational corporations. Familiarity with business essentials, as well as corporate law or intellectual property law would be helpful in this field.  In the public international law, practitioners would work on cases that involve dealings between sovereign nations.  Familiarity with comparative law or public international law would be most helpful for effective practice in this field. Both private and public international law are interdisciplinary in nature and would involve an understanding of the differences between common law and civil law systems across borders. Learn more at: International Law Association and American Society of International Law

                    </div>





                    <div className={styles.heading}>
                        Labor (Employment) Law
                    </div>
                    <div className={styles.text}>
                        Labor law is concerned with the relations between workers and their employers on matters ranging from wages and compensation, through harassment, to discrimination based on gender, disability, or age. Labor law often involves collective bargaining and unions. Attorneys in this field may represent individual clients, a union, a government regulatory agency, or an employer. Learn more at: National Employment Lawyers Association

                    </div>





                    <div className={styles.heading}>
                        Military Law
                    </div>
                    <div className={styles.text}>

                        Military law involves codes and procedures that govern legal matters in the armed forces. Since 1951, military law has been based on the Uniform Code of Military Justice. Legal experts in this field are typically members of the armed forces serving in the Judge Advocate General's Corps. Learn more at: Judge Advocates Association
                    </div>





                    <div className={styles.heading}>
                        Personal Injury Law
                    </div>
                    <div className={styles.text}>
                        Personal injury law deals with intentional or unintentional wrongdoing that affects individuals physically or psychologically. Experts in the field are well-versed in torts law and may work on cases involving medical malpractice, accidental collisions, product liability, wrongful death, or workplace injury. Many cases are settled out of court in this field of legal practice. Learn more at: National Association of Personal Injury Lawyers

                    </div>



                    <div className={styles.heading}>

                        Real Estate Law
                    </div>
                    <div className={styles.text}>
                        Real Estate law involves land or construction ownership, development, litigation, tenant rights, or landlord disputes. Attorneys in this field may work on residential or commercial transactions, review contracts, or work in planning and other government offices. Learn more at: Association of Real Estate Licence Law Officials


                    </div>





                    <div className={styles.heading}>
                        Tax Law
                    </div>
                    <div className={styles.text}>
                        Tax law is a dynamic field that deals with domestic and international transactions. Because of the frequent modifications to local, state, and federal codes and the complexity of fiscal policy that guides these changes, experts in tax law engage in continuous education at greater rates than in many other fields of law. Apart from ensuring the legality of the levies on economic transactions, tax lawyers help clients reduce fiscal liabilities. Learn more at: National Association of Tax Professionals

                    </div>






                    <div className={styles.heading}>
                        Admiralty (Maritime) Law
                    </div>
                    <div className={styles.text}>
                        Admiralty law regulates economic transactions and property disputes involving marine trade, sailors, navigation, or land-based activity that is maritime in nature. Admiralty Law is not, however, synonymous with the Law of the Sea, which is in the realm of international public law and deals with rights to navigation, minerals, or coastal waters jurisdiction.  Learn more at: The Maritime Law Association of the United States


                    </div>




                </div>
            </div>
        </>
    )
}

export default Help
